const SearchStatic = ({ staticData, handleSuggestionClick }) => {
    const sections = staticData.static.sections

    // console.log('sections', sections)

    return (
        <div className="search-static-outer">
            <div className="search-static-inner">
                <div className="search-static-stack">
                    {sections.map((s, index) => {
                        if (s.title === 'Top Searches') {
                            return (
                                <div
                                    className={`search-static-section static-section-${s.slug}`}
                                    key={index}
                                >
                                    <div className="search-static-title">
                                        {s.title}
                                    </div>
                                    <div className="search-static-content">
                                        <ul className="searches-list nostyle">
                                            {s.searches.map((search, i) => {
                                                return (
                                                    <li
                                                        className="search-item"
                                                        key={i}
                                                        onClick={() =>
                                                            handleSuggestionClick(
                                                                search.title
                                                            )
                                                        }
                                                    >
                                                        {search.title}
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            )
                        }
                        if (s.title === 'Top Classes + Events') {
                            return (
                                <div
                                    className={`search-static-section static-section-${s.slug}`}
                                    key={index}
                                >
                                    <div className="search-static-title">
                                        {s.title}{' '}
                                        <a
                                            href="/pages/all-classes-events"
                                            className="view-all"
                                        >
                                            View All »
                                        </a>
                                    </div>
                                    <div className="search-static-content">
                                        <ul className="classes-list nostyle">
                                            {s.classes.map((c, i) => {
                                                return (
                                                    <li
                                                        className="class-item"
                                                        key={i}
                                                    >
                                                        <a href={c.url}>
                                                            {c.title}
                                                        </a>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            )
                        }
                        return null
                    })}
                </div>
                {sections.map((s, index) => {
                    if (s.title === 'Top Categories') {
                        return (
                            <div
                                className={`search-static-section static-section-${s.slug}`}
                                key={index}
                            >
                                <div className="search-static-title">
                                    {s.title}
                                </div>
                                <div className="search-static-content">
                                    <ul className="categories-list nostyle">
                                        {s.categories.map((c, i) => {
                                            return (
                                                <li
                                                    className="category-item"
                                                    key={i}
                                                >
                                                    <div className="category-item-image">
                                                        <a href={c.url}>
                                                            <img
                                                                loading="lazy"
                                                                src={c.imageSrc}
                                                                alt={c.imageAlt}
                                                            />
                                                        </a>
                                                    </div>
                                                    <div className="category-item-title">
                                                        <a href={c.url}>
                                                            {c.title}
                                                        </a>
                                                    </div>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        )
                    }
                    return null
                })}
            </div>
        </div>
    )
}

export default SearchStatic
